import React from "react"
import autobind from "class-autobind"
import { Paper } from "material-ui"
import { IPosition, IPositionWorkInstructions, IScheduleBudgetDay, IWorkInstructions } from "../../models"
import AccountStore from "../../stores/AccountStore"
import { IScheduleBudgetDayPosition } from "../../models/data/scheduling/ScheduleBudgetDayPosition"
import _ from "lodash"
import PositionWorkInstructions from "./PositionWorkInstructions"
import PositionWorkInstructionsAddDialog from "./PositionWorkInstructionsAddDialog"
import strings from "../../localization/strings"

interface IProps {
  readonly: boolean
  scheduleBudgetDay: IScheduleBudgetDay
  update(scheduleBudgetDay): void
}

interface IState {
  positionList: IPosition[]
  loadingPositions: boolean
  showAddDialog: boolean
  positionBudgetItem: IScheduleBudgetDayPosition
}

export default class WorkInstructions extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      positionList: AccountStore.getCurrentAccount().PositionDefinitions,
      loadingPositions: false,
      showAddDialog: false,
      positionBudgetItem: null,
    }
    autobind(this)
  }

  componentDidMount() {
  }

  render() {
    return (
      <Paper style={{ marginTop: 10, marginBottom: 20, padding: 10, borderRadius: 10 }}>
        <b>{strings.Work_Instructions}</b>
        {!this.props.readonly &&
          <i
            className="fa fa-plus-circle"
            style={{ fontSize: 20, cursor: "pointer", marginLeft: 10 }}
            onClick={() => this.setState({ positionBudgetItem: null, showAddDialog: true })}
          />
        }

        {this.props.scheduleBudgetDay &&
          this.props.scheduleBudgetDay.WorkInstructions &&
          this.props.scheduleBudgetDay.WorkInstructions.PositionWorkInstructions.map((item, index) =>
            <PositionWorkInstructions
              readonly={this.props.readonly}
              key={index}
              positionWorkInstructions={item}
              update={() => {
                this.props.update(this.props.scheduleBudgetDay)
              }}
            />
          )
        }

        {this.state.showAddDialog &&
          <PositionWorkInstructionsAddDialog
            handleClose={() => { this.setState({ showAddDialog: false }) }}
            handleAdd={(position: IPosition) => {
              if (!this.props.scheduleBudgetDay.WorkInstructions) {
                this.props.scheduleBudgetDay.WorkInstructions = {
                  PositionWorkInstructions: []
                } as IWorkInstructions
              }
              if (!this.props.scheduleBudgetDay.WorkInstructions.PositionWorkInstructions) {
                this.props.scheduleBudgetDay.WorkInstructions.PositionWorkInstructions = []
              }

              this.props.scheduleBudgetDay.WorkInstructions.PositionWorkInstructions.push({
                PositionName: position.Name,
                BasePositionId: position.BasePositionId,
              } as IPositionWorkInstructions)

              this.props.update(this.props.scheduleBudgetDay)
              this.setState({ showAddDialog: false })
            }}
          />
        }

      </Paper>
    )
  }
}